import { getBoundingClientRect } from 'universal-element';
import { isStrictWechatMiniProgram } from './env';
/**
 * 获取指定元素的 rect 值
 * @param id  格式为： `#id`
 */
export async function getElementBoundingClientRect(id) {
    let getRect = getBoundingClientRect;
    if (isStrictWechatMiniProgram) {
        getRect = (selector) => {
            return new Promise((resolve) => {
                const ele = document.querySelector(selector);
                if (!ele || !ele._internal) {
                    if (process.env.NODE_ENV === 'development') {
                        console.warn('element not found', selector);
                    }
                    resolve([]);
                }
                ele._internal
                    .createSelectorQuery()
                    .select(selector)
                    .boundingClientRect()
                    .exec((res) => {
                    resolve(res);
                });
            });
        };
    }
    const rs = await getRect(`#${id}`).then((ret) => {
        const rect = {
            left: 0,
            bottom: 0,
            top: 0,
            right: 0,
            width: 0,
            height: 0,
            x: 0,
            y: 0,
        };
        if (ret && ret[0]) {
            const { left, bottom, top, right, width, height, x, y } = ret[0];
            return {
                ...rect,
                left,
                bottom,
                top,
                right,
                width,
                height,
                x,
                y,
            };
        }
        return rect;
    });
    return rs;
}
/**
 * 根据指定 Id 获取元素宽度
 * @param id
 */
export async function getWidth(id) {
    return (await getElementBoundingClientRect(id)).width;
}
